export default {
  Optional: "Optional",
  minOrderValueInputHeader: "Minimum order value",
  minOrderValueInputText: "Enable minimum order to set a minimum value.",
  minOrderValueText:
    "Customers won’t be able to make an order below the minimum order value.",
  minValue: "Minimum value",
};
